import { createAction, props } from '@ngrx/store';
import { blogsListPayload, blogsDetailPayload } from './blogs.model'; // Adjust the path as necessary

export const fetchBlogsList = createAction('[Data] Fetch Blogs List', props<{ payload: blogsListPayload }>());
export const fetchBlogsListSuccess = createAction('[Data] Fetch Blogs List Success', props<{ response: any }>());
export const fetchBlogsListFailure = createAction('[Data] Fetch Blogs List Failure', props<{ error: string }>());

export const fetchBlogsDetail = createAction('[Data] Fetch Blogs Detail', props<{ payload: blogsDetailPayload }>());
export const fetchBlogsDetailSuccess = createAction('[Data] Fetch Blogs Detail Success', props<{ response: any }>());
export const fetchBlogsDetailFailure = createAction('[Data] Fetch Blogs Detail Failure', props<{ error: string }>());

export const addUpdateBlog = createAction('[Data] Add Update Blog', props<{ payload: any }>());
export const addUpdateBlogSuccess = createAction('[Data] Add Update Blog Success', props<{ response: any }>());
export const addUpdateBlogFailure = createAction('[Data] Add Update Blog Failure', props<{ error: string }>());

export const deleteBlog = createAction('[Data] Delete Blog', props<{ payload: blogsDetailPayload }>());
export const deleteBlogSuccess = createAction('[Data] Delete Blog Success', props<{ response: any }>());
export const deleteBlogFailure = createAction('[Data] Delete Blog Failure', props<{ error: any }>());
